import { useQuery } from "@tanstack/react-query";
import { getCartItemsWithOffline, getOfflineCart, normalizeStoreId, normalizeBranchId } from "@/lib/offlineCart";
import { shouldPreferLocalData } from "@/lib/connectionQuality";
import { base44 } from "@/api/base44Client";
import { useStoreSession } from "@/hooks/useStoreSession";

/**
 * סל הסניף/ענף — מקוון: מהשרת (ומסנכרן ללוקאל), לא מקוון / 3G: מ־localStorage.
 */
export function useCartItemsQuery(storeId, options = {}) {
  const { enabled = true, branchId: branchIdOpt, ...rest } = options;
  const session = useStoreSession();
  const sid = normalizeStoreId(storeId);
  const bid = normalizeBranchId(
    branchIdOpt !== undefined ? branchIdOpt : session?.branchId
  );
  const preferLocal = shouldPreferLocalData();
  return useQuery({
    queryKey: ["cartItems", sid, bid || "main"],
    queryFn: () =>
      getCartItemsWithOffline(
        sid,
        () =>
          base44.entities.CartItem.list({
            store_id: sid,
            ...(bid ? { branch_id: bid } : {}),
          }),
        bid
      ),
    enabled: !!sid && enabled,
    staleTime: preferLocal ? 5 * 60 * 1000 : 30 * 1000,
    refetchOnWindowFocus: !preferLocal,
    refetchOnReconnect: true,
    networkMode: "offlineFirst",
    placeholderData: (prev) =>
      prev !== undefined && prev !== null
        ? prev
        : sid
          ? getOfflineCart(sid, bid)
          : [],
    ...rest,
  });
}
